import React from "react";
import Loader from "@components/LoaderComponent/loader";

/**
 * LoadingOverlay component - displays a loading overlay with spinner
 * @param {boolean} isLoading - Whether to show the loading overlay
 */
const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 flex justify-center items-center z-50">
      <Loader dots />
    </div>
  );
};

export default LoadingOverlay;
